import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import { shouldRedirectToWaitingListFromStorage } from "../helpers/openAccessWaitingList.helper";

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(private authService: AuthenticationHelper, private route: Router, private utility: UtilityHelper) {

    }

    canActivate() {
        if (this.authService.isLoggedIn()) {
            if (shouldRedirectToWaitingListFromStorage(this.utility)) {
                this.route.navigate(['/waiting-list']);
                return false;
            }
            return true;
        } else {
            this.route.navigate(['']);
            return false;
        }
    }
}